import React from 'react';
import store from '../../store/Store';
import './content.scss';

class Content extends React.Component {

  constructor(props) {
  	super(props)
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			
		})
	})
  }

  render() {
	  return (
	    <div className="Content">
	      	<div className="LeftContent">
	      		<div className="ContentBoxBlack">
		      		<div className="LeftTop">
		      			COMMUNITY DRIV
		      		</div>
		      	</div>
		      	<div className="ContentBoxWhite">
		      		<div className="LeftMiddle">
		      			COMMUNITY DRIV
		      		</div>
	      		</div>
		      	<div className="ContentBoxBlack">
		      		<div className="LeftBottom">
		      			COMMUNITY DRIV
		      		</div>
		      	</div>
	      	</div>
	      	<div className="RightContent">
		      	<div className="ContentBoxWhite">
		      		<div className="RightTop">
		      			EN DEVELOPMENT
		      		</div>
		      	</div>
		      	<div className="ContentBoxBlack">
		      		<div className="RightMiddle">
		      			EN DEVELOPMENT
		      		</div>
		      	</div>
		      	<div className="ContentBoxWhite">
		      		<div className="RightBottom">
		      			EN DEVELOPMENT
		      		</div>
		      	</div>
	      	</div>
	    </div>
	  );
	}
}

export default Content;
